// Send Logs on the web (docs/features/send-logs.md): ⋯ › Send Logs sends this page's recent log — the console ring
// (buffer.js) and the log panel's lines (core/log.js), redacted — to a Mac it has a link to, kept on disk until that Mac
// says it saved it (outbox.js, send.js); a Mac's Request Logs shows the ask card, and only its Send sends.
// Inside Cody's Android app the same tap also asks the phone to send its own native log (`CodyPhoneLogs.send()`, the
// phone's JavascriptInterface: sends and returns one short line), shown under the row.
//
// Its registration: the wire kind `logs` here, and `watchSendLogs(mac, link)`, which app.js calls once a Mac's link
// is up. app.js imports this module first, so the ring (buffer.js, imported first here) hears the page from the start.
import './buffer.js'
import { lines } from './buffer.js'
import { registerWire } from '../core/wire.js'
import { clientLog } from '../core/log.js'
import { readStamp } from '../core/build-stamp.js'
import { makeBundle, describeDevice } from './bundle.js'
import { SendLogs } from './send.js'
import { drawRow, drawAsk } from './view.js'

registerWire('logs', (link, payload, message) => { SendLogs.hear(link, message) })

let ask = null          // { key, name }: the Mac that asked, while its card shows
let phoneLine = ''      // what the phone said it did with its own log

const phone = () => (typeof globalThis.CodyPhoneLogs?.send === 'function' ? globalThis.CodyPhoneLogs : null)

/// The bundle's text, made the moment it is sent.
async function bundleText(asked) {
  const device = await describeDevice({ stamp: readStamp(document.getElementById('build')) })
  return makeBundle({ lines: lines(), appLog: clientLog, device, asked, made: new Date() })
}

function sendTo(key, asked) {
  SendLogs.send(key, bundleText, { asked }).catch((e) => console.warn('send logs: ' + (e?.message || e)))
}

/// The row's tap: this page's log to that Mac, and inside the phone app the phone's own, once.
function tap(key) {
  const p = phone()
  if (p) { try { phoneLine = String(p.send() ?? '') } catch (e) { phoneLine = 'Phone logs: ' + (e?.message || e) } }
  if (key) sendTo(key, false)
  draw()
}

function draw() {
  const rows = SendLogs.rows()
  const several = rows.length > 1
  const model = { rows: rows.map((r) => ({ key: r.key, label: several ? `Send Logs to ${r.name}` : 'Send Logs', line: r.line })), phoneLine }
  if (!model.rows.length && phone()) model.rows.push({ key: '', label: 'Send Logs', line: '' })
  drawRow(model, tap)
  drawAsk(ask && { title: 'Mac asked for logs', note: several ? ask.name : '' }, {
    send: () => { const key = ask?.key; ask = null; if (key) sendTo(key, true); draw() },
    later: () => { ask = null; draw() },
  })
}

SendLogs.onAsk = (key) => {
  ask = { key, name: SendLogs.rows().find((r) => r.key === key)?.name || 'the Mac' }
  draw()
}
SendLogs.on(draw)
SendLogs.load()
document.getElementById('more')?.addEventListener('click', draw)
draw()

/// The hook: this Mac's link is up — what is kept for it goes now, and the row offers it.
export function watchSendLogs(mac, link) {
  SendLogs.attach(mac, link).catch(() => {})
}
